import teczLogo from '../Assets/teczo.png';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="ew-footer" id="contact">
      <div className="ew-footer__inner">

        <div className="ew-footer__grid">

          {/* Left: Brand + LinkedIn */}
          <div className="ew-footer__brand">
            <div className="ew-footer__logo-wrap">
              <img src={teczLogo} alt="Teczo" className="ew-footer__logo-img" />
              <span className="ew-footer__logo-divider">|</span>
              <div>
                <div className="ew-footer__logo-name">EnergyWorks</div>
                <div className="ew-footer__logo-sub">Teczo Subsidiary</div>
              </div>
            </div>
            <p className="ew-footer__desc">
              Architecting the operating system for energy industries — bridging
              physical assets with digital intelligence.
            </p>
            <a href="https://www.linkedin.com/company/teczo-sdn-bhd" target="_blank" rel="noreferrer" className="ew-footer__linkedin">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor"><path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z"/><rect x="2" y="9" width="4" height="12"/><circle cx="4" cy="4" r="2"/></svg>
            </a>
          </div>

          {/* Middle: Contact Us */}
          <div className="ew-footer__contact-block">
            <h3 className="ew-footer__section-title">Contact Us</h3>
            <div className="ew-footer__contact-cols">
              <div className="ew-footer__addresses">
                <div className="ew-footer__address-group">
                  <p className="ew-footer__address-label">Headquarters (Malaysia)</p>
                  <div className="ew-footer__address-text">
                    <p>Suite 12, WORQ Sunway Putra,</p>
                    <p>Level 4-1, Sunway Putra Mall,</p>
                    <p>100, Jalan Putra, Chow Kit,</p>
                    <p>50350 Kuala Lumpur,</p>
                    <p>W.P. Kuala Lumpur, Malaysia</p>
                  </div>
                </div>
                <div className="ew-footer__address-group">
                  <p className="ew-footer__address-label">Regional Office (Australia)</p>
                  <div className="ew-footer__address-text">
                    <p>40/57 Frederick Street,</p>
                    <p>Belmont, 6104,</p>
                    <p>Western Australia, Australia</p>
                  </div>
                </div>
              </div>
              <div className="ew-footer__inquiries">
                <p className="ew-footer__address-label">Inquiries</p>
                <a href="mailto:connect@teczo.co" className="ew-footer__email">connect@teczo.co</a>
                <p className="ew-footer__response-time">Response time: Within 24 hours</p>
              </div>
            </div>
          </div>

          {/* Right: Sitemap */}
          <div className="ew-footer__sitemap">
            <h3 className="ew-footer__section-title">Sitemap</h3>
            <ul className="ew-footer__links">
              <li><a href="/">Home</a></li>
              <li><a href="/about">About Us</a></li>
              <li><a href="/solutions">Solutions</a></li>
              <li><a href="/products">Products</a></li>
              <li><a href="/contact">Contact Us</a></li>
            </ul>
          </div>

        </div>

        {/* Bottom bar */}
        <div className="ew-footer__bottom">
          <p className="ew-footer__copy">
            &copy; 2026 Teczo. All Rights Reserved. Powered by VeltrixArcStudio
          </p>
        </div>

      </div>
    </footer>
  );
};

export default Footer;
